export default "__VITE_ASSET__lyTM9tez__"